<template>
    <div>
        <!-- 来电弹窗 -->
        <div role="dialog" class="modal fade" id="incoming-call-dialog" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="usr-info">
                            <img class="usr-pho" src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-7/1658388218664/pho.png">
                            <!--用于来电展示，接入方通过来电sn查询获取来电姓名 -->
                            <p class="usr-name">{{callMessage.customerName}}</p>
                            <p class="incoming-call-tip">邀请您通话</p>
                        </div>
                        <div class="op-btns">
                            <div class="incoming-call-reject">
                                <img
                                        @click="rejectCall()"
                                        src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433175110/reject.png"
                                >
                                <p class="op-txt">挂断</p>
                            </div>
                            <div class="incoming-call-video">
                                <img
                                        @click="answerCall(0)"
                                        src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433226356/videoCall.png"
                                >
                                <p class="op-txt">视频通话</p>
                            </div>
                            <div class="incoming-call-audio">
                                <img
                                        @click="answerCall(1)"
                                        src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433255465/audioCall.png"
                                >
                                <p class="op-txt">语音通话</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 去电响铃 -->
        <div id="outing-call-view" style="display: none;">
            <div class="peer-info">
                <img class="peer-pho" src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-7/1658388218664/pho.png">
                <!-- 业务方根据实际呼叫用户进行替换 -->
                <p class="peer-name">{{customerName}}</p>
                <p class="outing-call-tip">设备正在响铃中，请不要挂断...</p>
            </div>
            <div class="op-btns">
                <div class="out-call-mode">
                    <img
                            @click="changeMode()"
                            src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png"
                    >
                    <p class="out-call-mode-txt">视频呼叫</p>
                </div>
                <!-- <div class="out-call-mode">
                    <img
                          @click="changeMode()"
                        src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png"
                    >
                    <p>语音呼叫</p>
                </div> -->
                <div>
                    <img
                            @click="dropCall()"
                            src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433175110/reject.png"
                    >
                    <p style="color: #E24940">挂断</p>
                </div>
            </div>
        </div>

        <!-- 通话界面 -->
        <div id="call-view" style="display: none;">
            <div class="peer-view main-view">
                <video id='video-peer' autoPlay></video>
                <audio id='audio-peer' autoPlay></audio>
                <div class="audio-tip-wrap">
                    <!-- <p class="audio-name online-ellipsis">对端姓名</p> -->
                    <p class="audio-call">语音通话中</p>
                </div>
            </div>
            <div class="local-view sub-view">
                <video id='video-local' autoPlay></video>
                <audio id='audio-local' autoPlay></audio>
                <div class="audio-tip-wrap">
                    <p class="audio-name online-ellipsis">本机</p>
                    <p class="audio-call">语音通话中</p>
                </div>
            </div>
            <div class="op-btns">
                <div class="mute-change-btn">
                    <img
                            @click="changeMute()"
                            src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279806/quite0.png"
                    >
                    <p class="a-mute">静音</p>
                </div>
                <!-- <div>
                    <img
                          @click="changeAudioMute"
                        src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279209/quite.png"
                    >
                    <p class="a-mute">已静音</p>
                </div> -->
                <div class="mode-change-btn">
                    <img
                            @click="changeMode()"
                            src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png"
                    >
                    <p class="v-mode">视频通话</p>
                </div>
                <!-- <div>
                    <img
                          @click="changeMode"
                        src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png"
                    >
                    <p>语音通话</p>
                </div> -->
                <div>
                    <img
                            @click="dropCall()"
                            src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433175110/reject.png"
                    >
                    <p style="color: #E24940">挂断</p>
                </div>
            </div>
        </div>
        <audio id="ring-music" loop>
            <source src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-9/1662024495462/ring_new.mp3" type="audio/mpeg">
        </audio>
        <div class="alert alert-warning fade in" id="message-alert">
            <a href="#" class="close" data-dismiss="alert">
                &times;
            </a>
            <span class="call-message">呼叫超时，请稍后再试</span>
        </div>

    </div>
</template>

<script>
    import request from "@/utils/request.js"
    import baseURL from "@/api/baseURL"
    import axios from "axios"
    import exportVue from "@/utils/exportVue"
    import { volunteerArchiveApi } from "../api/http"
    export default {
        name: "msg",
        mounted() {},
        data() {
            return {
                rtctoken: '',
                uid: '',
                rtc_appid: '',
                duerRtc: null,
                enbaleRtcDebugLog:true,
                callInfo :{},
                duerRtcSdk:window.DUER_rtcsdk,
                callAppid:'',
                callAddress:'',
                flag:true,
                htmlVideo:navigator,
                callMessage:{},
                customerName:''
            }
        },
        props: ['xiaoduPic','deviceXiaodu'],
        created() {
            this.callInfo = {
                mute: false,
                    mode: this.duerRtcSdk.CallMode.AUDIO_VIDEO
            }

        },
        mounted(){
            this.getDevice()
        },
        watch:{
            xiaoduPic: {
                handler(val) {
                    //进行具体操作
                    let _this = this;
                    this.rtctoken = sessionStorage.getItem("rtctoken")//获取小度对接的用于初始化rtcsdk
                    this.uid = sessionStorage.getItem("uid")//获取小度对接用户唯一标识，需要保证在分配的appid下唯一
                    this.rtc_appid = sessionStorage.getItem("rtc_appid")//小度分配给接入方的通话应用标识，标识一个音视频服务接入方
                    this.changeView();
                    const uri = new _this.duerRtcSdk.CallUri( sessionStorage.getItem("uid"), sessionStorage.getItem("rtcAppid"));
                    console.log(uri)
                    const loginParams = {
                        uri: uri,
                        uid: sessionStorage.getItem("uid"),
                        appId: sessionStorage.getItem("rtcAppid"),
                        appName: 'appName',
                        token:    sessionStorage.getItem("rtctoken")
                    };
                    if(this.rtctoken != null &&  this.flag){
                        _this.callInfo.loginParams = loginParams;
                        _this.rtcListener(loginParams);
                        this.flag = false;
                    }


                },
                //立即执行
                immediate: true,
            },
            deviceXiaodu: {
                handler(val) {
                    let _this= this;
                    console.log(val)
                    _this.customerName = val.customerName;
                    // _this.getDevice()
                    _this.duerRtc.muteVideo(false)
                    _this.makeCall(val.callAppid, val.callAddress, 0, window.DUER_rtcsdk.CallerRole.CALL_CENTER);
                },
                //立即执行
                immediate: true,
            }


        },
        methods: {
            // 设置事件回调监听器
            rtcListener(loginParams) {
                let _this = this;
                _this.duerRtc = new _this.duerRtcSdk.RtcContext({
                    onAuthStatusChanged: auth => {
                        if (auth.success) {
                            console.log('auth.success');
                            // this.setState({ isLogin: true })
                        } else {
                            switch (auth.code) {
                                case _this.duerRtcSdk.AuthCode.PARAM_ERROR:
                                case _this.duerRtcSdk.AuthCode.APPID_INVALID: {
                                    // 联调阶段可能遇到的错误
                                    break
                                }
                                case _this.duerRtcSdk.AuthCode.TOKEN_INVALID:
                                case _this.duerRtcSdk.AuthCode.TOKEN_EXPIRED: {
                                    // 重新刷新token
                                    break
                                }
                                case _this.duerRtcSdk.AuthCode.NO_ERROR:
                                case _this.duerRtcSdk.AuthCode.OTHER_DEVICE_LOGIN: {
                                    break
                                }
                            }
                        }
                    }
                }, true);
                _this.duerRtc.setCallListener({
                    onIncomingCall: intent => {
                        const serviceInfo = intent.serviceInfo
                            && JSON.parse(intent.serviceInfo)
                            || {};
                        intent.serviceInfo = serviceInfo;
                        Object.assign(_this.callInfo, intent);
                        _this.incomingViewShow();
                        console.log("onIncomingCall", intent);
                        console.log(_this.callInfo);
                        _this.$http
                            .request({
                                url: "/sqyl/admin/equipment/info/findList",
                                method: "POST",
                                data: {
                                    equipmentNumber:intent.serviceInfo.sn,
                                    pageNo: 1,
                                    pageSize: 10
                                }
                            })
                            .then(res => {
                                if (res.code === 200) {
                                    if (res.content == null || res.content == "null") {
                                       console.log(res)
                                        return
                                    }
                                    this.callMessage = res.content.list[0];
                                }
                                return
                            })
                        serviceInfo.sn
                        _this.callMessage=intent;
                    },
                    onAddConfereeStateChanged: state => {
                        console.log("onAddConfereeStateChanged", state);
                    },
                    onCallReplaced: replaced => {
                        console.log("onCallReplaced", replaced);
                    },
                    onCallStateChanged: stateInfo => {
                        if (stateInfo.state === _this.duerRtcSdk.CallState.RINGBACK) {
                            // 被叫开始响铃
                            _this.ringViewShow();
                        }
                        else if (stateInfo.state === _this.duerRtcSdk.CallState.DISCONNECTED) {
                            // 通话已经断开
                            _this.freeCallView();
                            if (stateInfo.reason === _this.duerRtcSdk.CallReason.TIMEOUT) {
                                // 呼叫超时
                                _this.callTimeout();
                            }
                        }
                        else if (stateInfo.state === _this.duerRtcSdk.CallState.CONNECTED) {
                            // 通话被正常接听
                            _this.callViewShow();
                        }
                        console.log("onCallStateChanged", stateInfo);
                    },
                    onConfereeLayout: layouts => {
                        _this.setLayouts(layouts);
                        console.log("onConfereeLayout", layouts);
                    },
                    onRecordStateChanged: recordStateInfo => {
                        console.log("onRecordStateChanged", recordStateInfo);
                    }
                });
                _this.duerRtc.setConnectListener({
                    onConnectionChanged: conn => {
                        if (conn === 2) {
                            // 长链接已建立
                            // _this.makeCall(_this.callAppid, _this.callAddress, 1, window.DUER_rtcsdk.CallerRole.CALL_CENTER);
                        }
                        if (conn === 3) {
                            // 长链接已断开
                            _this.duerRtc = null;
                        }
                        console.log("onConnectionChanged", conn);
                    }
                });
                _this.duerRtc.setMediaDeviceListener({
                    // 麦克风/摄像头状态
                    onMediaDeviceStateChanged: (device, state, error) => {

                    }
                });
                _this.rtcConnect(loginParams);
            },
            // 建立长连接
            rtcConnect(loginParams) {
                let _this = this;
                let {uid, appId} = loginParams;
                const uri = new _this.duerRtcSdk.CallUri(uid, appId);
                loginParams.uri = uri;
                _this.duerRtc.login(loginParams);
            },

            // 呼叫
            makeCall(appId, uid, callMode, callerRole =window.DUER_rtcsdk.CallerRole.CALL_CENTER) {
                let _this = this;
                const calleeUri = new _this.duerRtcSdk.CallUri(uid, appId);
                console.log(calleeUri)
                let intent = _this.duerRtcSdk.MakeCallIntent(calleeUri, _this.duerRtcSdk.CallMode.AUDIO_VIDEO);
                callMode && (intent.callMode = callMode);
                callerRole && (intent.callerRole = callerRole);
                _this.callInfo.callMode = callMode;
                console.log(intent)
                _this.callInfo.index= intent.index;
                const result =_this.duerRtc.makeCall(intent)
                console.info('makeCall action', intent, result)
                if (_this.duerRtcSdk.CallReason.NORMAL == result) {
                    // 呼出成功

                } else if (_this.duerRtcSdk.CallReason.ALREADY_IN_CALL == result || CallReason.EXCEPTION_INPUT_ILLEGAL == result) {
                    console.error('makeCall resaon', _this.duerRtcSdk.CallReasonMap.get(result))
                }
                else {
                    // 其他原因，目前不会出现
                    console.warn('makeCall res', result)
                }
            },
            // 来电接听
            answerCall(mode) {
                let _this = this;
                _this.duerRtc.answerCall(_this.callInfo.index, mode, false);
                _this.callInfo.callMode = mode;
            },
            // 拒接来电
            rejectCall() {
                let _this = this;
                _this.duerRtc.rejectIncomingCall(_this.callInfo.index, 'REJECT_CALL_USER_REASON');
                // _this.duerRtc.rejectIncomingCall(_this.callInfo.index, 'REJECT_CALL_USER_REASON');
            },
            // 改变通话模式 type 1去电  2通话中
            changeMode() {
                let _this = this;
                const mode = _this.callInfo.callMode == _this.duerRtcSdk.CallMode.AUDIO_VIDEO
                    ? _this.duerRtcSdk.CallMode.AUDIO_ONLY
                    : _this.duerRtcSdk.CallMode.AUDIO_VIDEO;
                console.log(mode, _this.callInfo.callMode);
                if (mode == _this.duerRtcSdk.CallMode.AUDIO_VIDEO) {
                    $('.out-call-mode img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
                    $('.out-call-mode-txt').text('语音通话');
                    $('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
                    $('.v-mode').text('语音通话');
                    $('.audio-tip-wrap').hide();
                } else if (mode == _this.duerRtcSdk.CallMode.AUDIO_ONLY) {
                    $('.out-call-mode img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
                    $('.out-call-mode-txt').text('视频通话');
                    $('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
                    $('.v-mode').text('视频通话');
                    $('.audio-tip-wrap').show();
                }
                _this.duerRtc.changeCallMode(mode);
                _this.callInfo.callMode = mode;
            },
            // 静音状态切换
            changeMute() {
                let _this = this;
                if (_this.callInfo.mute) {
                    $('.mute-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279806/quite0.png');
                    $('.a-mute').text('静音');
                } else {
                    $('.mute-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279209/quite.png');
                    $('.a-mute').text('已静音');
                }
                _this.callInfo.mute = !_this.callInfo.mute;
                _this.duerRtc.muteAudio(_this.callInfo.mute);
            },
            // 挂断通话
            dropCall() {
                let _this = this;
                _this.duerRtc.dropCall('DROP_CALL_USER_REASON');
            },
            // 设置音视频
            setLayouts(layouts) {
                let _this = this;
                if (!layouts) {
                    return;
                }
                // const audioLocal = $('#audio-local').get(0);
                // const videoLocal = $('#video-local').get(0);
                // const audioPeer = $('#audio-peer').get(0);
                // const videoPeer = $('#video-peer').get(0);
                const audioLocal = document.getElementById('audio-local');
                const videoLocal = document.getElementById('video-local');
                const audioPeer = document.getElementById('audio-peer');
                const videoPeer = document.getElementById('video-peer');
                const [layoutLocal, layoutPeer] = layouts;
                if (layoutLocal.videoTrack) {
                    $('#video-local').show();
                    $('.local-view .audio-tip-wrap').hide();
                    const stream = new MediaStream;
                    stream.addTrack(layoutLocal.videoTrack);
                    videoLocal.srcObject = stream;
                }
                else {
                    $('#video-local').hide();
                    $('.local-view .audio-tip-wrap').show();
                }
                if (layoutLocal.audioTrack && !layoutLocal.isLocal) {
                    const stream = new MediaStream;
                    stream.addTrack(layoutLocal.audioTrack);
                    audioLocal.srcObject = stream;
                }
                if (layoutPeer.videoTrack) {
                    $('#video-peer').show();
                    $('.peer-view .audio-tip-wrap').hide();
                    const stream = new MediaStream;
                    stream.addTrack(layoutPeer.videoTrack);
                    videoPeer.srcObject = stream;
                }
                else {
                    $('#video-peer').hide();
                    $('.peer-view .audio-tip-wrap').show();
                }
                if (layoutPeer.audioTrack) {
                    const stream = new MediaStream;
                    stream.addTrack(layoutPeer.audioTrack);
                    audioPeer.srcObject = stream;
                }
            },
            // 视频大小窗口切换事件
            changeView() {
                let _this = this;
                $('.peer-view').click(_ => {
                    const cList = $('.peer-view').attr('class');
                    if (~cList.indexOf('sub-view')) {
                        $('.peer-view').attr('class', 'peer-view main-view');
                        $('.local-view').attr('class', 'local-view sub-view');
                    }
                });
                $('.local-view').click(_ => {
                    const cList = $('.local-view').attr('class');
                    if (~cList.indexOf('sub-view')) {
                        $('.local-view').attr('class', 'local-view main-view');
                        $('.peer-view').attr('class', 'peer-view sub-view');
                    }
                });
            },
            // 去电响铃时界面展示
            ringViewShow() {
                let _this = this;
                $('#ring-music').get(0).play();
                $('.peer-name').text(_this.callInfo.name);
                console.log(_this.callInfo)
                if (_this.callInfo.callMode == _this.duerRtcSdk.CallMode.AUDIO_VIDEO) {
                    // 当前为视频通话
                    $('.out-call-mode img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
                    $('.out-call-mode-txt').text('语音通话');
                } else if (_this.callInfo.callMode == _this.duerRtcSdk.CallMode.AUDIO_ONLY) {
                    // 当前为音频通话
                    $('.out-call-mode img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
                    $('.out-call-mode-txt').text('视频通话');
                }
                $('#outing-call-view').show();

            },
            // 收到来电
            incomingViewShow() {
                let _this = this;
                // _this.xiaoduPic = true;
                $('#incoming-call-dialog').modal('show');
                $('#ring-music').get(0).play();
            },
            // 空闲状态
            freeCallView() {
                let _this = this;
                $('#outing-call-view').hide();
                $('#call-view').hide();
                $('#incoming-call-dialog').modal('hide');
                $('#ring-music').get(0).pause();
                Object.assign(_this.callInfo, {
                    mute: false
                });
            },
            // 通话正常接听
            callViewShow() {
                let _this = this;
                $('#ring-music').get(0).pause();
                $('#incoming-call-dialog').modal('hide');

                $('#outing-call-view').hide();
                if (_this.callInfo.mute) {
                    // 已静音
                    $('.mute-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279209/quite.png');
                    $('.a-mute').text('已静音');
                } else {
                    $('.mute-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279806/quite0.png');
                    $('.a-mute').text('静音');
                }
                if (_this.callInfo.callMode == _this.duerRtcSdk.CallMode.AUDIO_VIDEO) {
                    // 当前为视频通话
                    $('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
                    $('.v-mode').text('语音通话');
                    $('.audio-tip-wrap').hide();
                } else if (_this.callInfo.callMode == _this.duerRtcSdk.CallMode.AUDIO_ONLY) {
                    // 当前为音频通话
                    $('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
                    $('.v-mode').text('视频通话');
                    $('.audio-tip-wrap').show();
                }
                $('#call-view').show();
            },
            // 呼叫超时
            callTimeout() {
                let _this = this;
                $('#outing-call-view').hide();
                $('#message-alert').show();
            },
            // 获取浏览器权限，根据实际情况调用，只限于用户没有做过授权
            getDevice() {

            },
            // 定时获取摄像头麦克风权限，根据业务实际情况调用
            // 用于定位音视频是否因为权限问题不显示
            // setInterval(_ => {
            //     getDevice();
            // }, 10000);
        },
    }
</script>
<style  scoped>
    /*小度*/
    body {
        background-color: #141e30;
    }
    #login-form, #device-form {
        width: 500px;
        margin: 20px auto 20px;
    }
    .usr-info {
        text-align: center;
    }
    .usr-pho {
        margin-top: 35px;
        width: 120px;
        height: 120px;
    }
    .usr-name {
        margin-top: 10px;
        font-weight: 500;
        font-size: 30px;
        line-height: 42px;
        color: #1A1A1A;
    }
    .incoming-call-tip {
        font-size: 16px;
        line-height: 22px;
        color: #666666;
    }
    .op-btns {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .op-btns img {
        width: 80px;
        height: 80px;
        margin: 16px 40px;
        cursor: pointer;
    }
    .op-txt {
        line-height: 20px;
        text-align: center;
    }
    #outing-call-view, #call-view {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 10052;
        background: #3c3667;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }
    #outing-call-view .op-btns {
        margin-top: 50px;
    }
    .peer-pho {
        width: 104px;
        height: 104px;
        margin-top: 50px;
    }
    .peer-name {
        font-size: 60px;
        line-height: 86px;
    }
    .outing-call-tip {
        font-size: 42px;
        line-height: 60px;
        color: rgba(225, 225, 225, .5);
    }
    #call-view .op-btns {
        position: absolute;
        bottom: 50px;
    }
    .main-view {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        background-image: url('https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661773897681/audioBg.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        color: #fff;
        text-align: center;
    }
    .main-view video {
        width: 100%;
        object-fit: fill;
    }
    .main-view .audio-name {
        margin-top: 100px;
        font-size: 62px;
        line-height: 87px;
    }
    .main-view .audio-call {
        font-size: 36px;
        line-height: 50px;
        color: rgba(225, 225, 225, .5);
        margin-top: 17px;
    }
    .main-view .audio-tip-wrap {
        position: absolute;
        top: 0;
    }
    .sub-view {
        width: 320px;
        height: 192px;
        position: absolute;
        left: 48px;
        top: 48px;
        background-image: url('https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661773897681/audioBg.png');
        background-repeat: no-repeat;
        background-size: 100%;
        color: #fff;
        z-index: 1;
    }
    .sub-view video {
        width: 320px;
        height: 192px;
        object-fit: fill;
    }
    .sub-view .audio-tip-wrap {
        position: absolute;
        bottom: 10px;
        right: 10px;
    }
    .sub-view .audio-name {
        font-size: 48px;
        line-height: 67px;
        max-width: 300px;
    }
    .sub-view .audio-call {
        font-size: 24px;
        line-height: 34px;
        text-align: right;
    }
    #message-alert {
        position: fixed;
        z-index: 1053;
        width: 300px;
        right: 0;
        top: 10px;
        display: none;
    }
    .desc-title {
        text-align: center;
        margin-bottom: 20px;
    }
</style>
